import { showNotification } from '../util/notifications'
import { useMutation } from '@apollo/client/react'
import AddRequest from '../graphql/queries/AddRequest'

export default function useQueueTrack(roomId) {

    const [ addRequestMutation ] = useMutation(AddRequest)

    async function queueTrack(track, silent) {
        try {
            await addRequestMutation({ variables: { roomId: roomId, trackId: track.id } })
            if (!silent)
                showNotification({content: <span>Added <i>{track.title}</i> to the queue.</span>})
        } catch (error) {
            console.error(`failed to queue track`, error)
        }
    }

    return queueTrack
}
